import { render, staticRenderFns } from "./OrderDetailsV2.vue?vue&type=template&id=09974f9d&scoped=true&"
import script from "./OrderDetailsV2.vue?vue&type=script&lang=js&"
export * from "./OrderDetailsV2.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailsV2.vue?vue&type=style&index=0&id=09974f9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09974f9d",
  null
  
)

export default component.exports